var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5925 2.90105C14.6804 1.95725 13.4063 1.4375 12 1.4375C10.5863 1.4375 9.30801 1.9541 8.40004 2.89207C7.48223 3.84037 7.03505 5.12918 7.14005 6.52086C7.34817 9.26648 9.52833 11.5 12 11.5C14.4718 11.5 16.6482 9.26693 16.8596 6.52176C16.966 5.14265 16.516 3.85654 15.5925 2.90105Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2503 21.5625H3.75027C3.5343 21.5652 3.32042 21.5217 3.12419 21.4352C2.92796 21.3487 2.75432 21.2214 2.61589 21.0625C2.31121 20.7135 2.18839 20.2369 2.27933 19.7548C2.67496 17.6516 3.90964 15.8848 5.85027 14.6445C7.57433 13.5435 9.75823 12.9375 12.0003 12.9375C14.2423 12.9375 16.4262 13.5439 18.1503 14.6445C20.0909 15.8844 21.3256 17.6512 21.7212 19.7544C21.8121 20.2364 21.6893 20.713 21.3846 21.0621C21.2463 21.221 21.0726 21.3484 20.8764 21.435C20.6802 21.5216 20.4663 21.5651 20.2503 21.5625V21.5625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user2.e6f190121d418713dc25685b8812336e.svg";
export { ForwardRef as ReactComponent };